import React from 'react';

/**
 * WaitlistCardSkeleton - Loading skeleton for WaitlistCard
 * Displays placeholder while waitlist data is loading
 */
function WaitlistCardSkeleton() {
  return (
    <div className="bg-white border border-gray-200 rounded-lg p-4 animate-pulse">
      {/* Header */}
      <div className="flex items-start justify-between mb-3">
        <div className="flex-1">
          <div className="h-6 bg-gray-200 rounded w-2/3 mb-2"></div>
          <div className="flex items-center gap-2">
            <div className="h-4 w-4 bg-gray-200 rounded"></div>
            <div className="h-4 bg-gray-200 rounded w-32"></div>
          </div>
        </div>
        <div className="h-6 w-16 bg-gray-200 rounded-full"></div>
      </div>

      {/* Position Info */}
      <div className="bg-gray-50 border border-gray-200 rounded-md p-3 mb-3">
        <div className="h-4 bg-gray-200 rounded w-40 mb-2"></div>
        <div className="h-3 bg-gray-200 rounded w-32"></div>
      </div>

      {/* Actions */}
      <div className="flex items-center justify-end gap-2 pt-2 border-t border-gray-200">
        <div className="h-8 w-24 bg-gray-200 rounded"></div>
      </div>
    </div>
  );
}

export default WaitlistCardSkeleton;
